import { Injectable } from '@angular/core';

import { NOT_APPLICABLE, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

@Injectable({ providedIn: 'root' })
export class TimeFilterTrackingService {
    constructor(private trackingService: TrackingService) {}
    trackingCalendarNavigation(calendarTrackingModel: CalendarTrackingModel): void {
        const trackingObject = {
            [trackingConstants.COMPONENT_ACTION_EVENT]: CalendarTracking.ActionEvent,
            [trackingConstants.COMPONENT_POSITION_EVENT]: calendarTrackingModel.positionEvent,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: CalendarTracking.EventDetails,
        };
        if (
            calendarTrackingModel.locationEvent === TimeFrameLocation.FeaturedPage ||
            calendarTrackingModel.locationEvent === TimeFrameLocation.CompetitionsPage
        ) {
            this.trackingService.track(trackingConstants.EVENT_TRACKING, {
                ...trackingObject,
                [trackingConstants.COMPONENT_CATEGORY_EVENT]: CalendarTracking.TopItemCategoryEvent,
                [trackingConstants.COMPONENT_LABEL_EVENT]: CalendarTracking.TopItemLabelEvent,
                [trackingConstants.COMPONENT_LOCATION_EVENT]: CalendarTracking.NotApplicable,
                [trackingConstants.COMPONENT_CONTENT_POSITION]: calendarTrackingModel.contentPosition?.toString() ?? NOT_APPLICABLE,
                [trackingConstants.COMPONENT_URL_CLICKED]: calendarTrackingModel.urlClicked,
            });
        } else {
            this.trackingService.track(trackingConstants.EVENT_TRACKING, {
                ...trackingObject,
                [trackingConstants.COMPONENT_CATEGORY_EVENT]: CalendarTracking.CategoryEvent,
                [trackingConstants.COMPONENT_LABEL_EVENT]: CalendarTracking.LabelEvent,
                [trackingConstants.COMPONENT_URL_CLICKED]: CalendarTracking.NotApplicable,
                [trackingConstants.COMPONENT_LOCATION_EVENT]: calendarTrackingModel.locationEvent,
            });
        }
    }
}

export interface CalendarTrackingModel {
    positionEvent?: string;
    locationEvent?: string;
    urlClicked?: string;
    pageLayout?: string;
    contentPosition?: number;
}

export enum CalendarTracking {
    CategoryEvent = 'Sports Calendar',
    NotApplicable = 'not applicable',
    LabelEvent = 'navigation',
    ActionEvent = 'click',
    EventDetails = 'time frame',
    TopItemCategoryEvent = 'Top Items Modules',
    TopItemLabelEvent = 'Time Frames',
}

export enum TimeFrameLocation {
    AzMenu = 'AZ Menu',
    FeaturedPage = 'Featured',
    CompetitionsPage = 'Competetions',
    CalendarPage = 'calendar page',
}
